import { current } from "@reduxjs/toolkit";
import Class from "./Class";
function Day({day, dayName, windowWidth, setCurrentDay, currentDay, dayNumber, weekMode}) {
 // console.log("WEEKMODE", weekMode, currentDay)
    return (
        <div class="col">
      {windowWidth > 1335 ?
       dayNumber > 0 ?
       <h4>{dayName}<br/>Day {dayNumber}</h4> : <h4>{dayName}<br/>No Day</h4>
       :
       <div className="row">
        <div className="col-3">
        <button class="btn btn-primary me-3 mobile" onClick={() => setCurrentDay((day) => day-1)} id="back-mobile" disabled={weekMode? currentDay === 0 : currentDay===0}>{"<"}</button>
        </div>
        <div className="col-6">
       <h4>{dayNumber > 0 ? <span class="mobile">{dayName}<br/>Day {dayNumber}</span> : <span class="mobile">{dayName}<br/>No Day</span>}</h4>
       </div>
        <div className="col-3">
        <button class="btn btn-primary ms-3 mobile" onClick={() => setCurrentDay((day) => day+1)} id="next-mobile"  disabled={weekMode ? currentDay === 4: currentDay === 7} >{">"}</button>
        </div>
        </div>}
       <div class="d-flex">
       <ul class="mx-auto justify-content-center">

       
         {day.map((block) => {
                return <Class block={block} />
         })
         }
         </ul>
   </div>
     </div>
    )
}
export default Day;